const actionTypes = require('constants/actionTypes');

function changeSearchType(selectedType) {
    return {
        type: actionTypes.BROKER_FUNDAMENTAL_ANALYSIS_CHANGE_SEARCH_TYPE,
        selectedType
    };
}

function changeSector(value) {
    return {
        type: actionTypes.BROKER_FUNDAMENTAL_ANALYSIS_CHANGE_SECTOR,
        value
    };
}

function changeDateFrom(value) {
    return {
        type: actionTypes.BROKER_FUNDAMENTAL_ANALYSIS_CHANGE_DATE_FROM,
        value
    };
}

function changeDateTo(value) {
    return {
        type: actionTypes.BROKER_FUNDAMENTAL_ANALYSIS_CHANGE_DATE_TO,
        value
    };
}

function changeValue(value) {
    return {
        type: actionTypes.BROKER_FUNDAMENTAL_ANALYSIS_CHANGE_VALUE,
        value
    };
}

function submit(value) {
    return {
        type: actionTypes.BROKER_FUNDAMENTAL_ANALYSIS_SUBMIT,
        value
    };
}

function clearForm(value) {
    return {
        type: actionTypes.BROKER_FUNDAMENTAL_ANALYSIS_CLEAR,
        value
    };
}

module.exports = {
  changeSearchType,
  changeSector,
  changeDateFrom,
  changeDateTo,
  changeValue,
  submit,
  clearForm
}
